import {
    SET_DIVISIONS
} from './DivisionsType';


const reducers = (state = [], action: any) => {
    if (action.type === SET_DIVISIONS) {
        return {
            ...state,
            divisionsDropDownList: action.divisionsDropDownList,
        };
    }
    else {
        return state;
    }
}

export {
    reducers
}